import { GLOBAL_CONSTANTS } from 'assets/js/utils/constants.js'

const SELECTORS = {
  controllerVideo: '.js-controller-video',
  skip: '.js-controller-video__skip',
  video: 'video',
  image: '.js-controller-video-image-container',
  getController: '.controller-carousel__header__get-controller',
  controllerCarousel: '.js-controller-carousel'
}

class ControllerVideo {
  constructor (element) {
    this.element = element
    this.emitter = GLOBAL_CONSTANTS.UTILS.EMITTER
    this.observer = this.registerObserver()
    this.emittedOnce = false

    this.video = this.element.querySelector(SELECTORS.video)
    this.image = this.element.querySelector(SELECTORS.image)
    this.skip = this.element.querySelector(SELECTORS.skip)
    this.getController = document.querySelector(SELECTORS.getController)
    this.controllerCarousel = document.querySelector(SELECTORS.controllerCarousel)
    this.init()
  }

  init() {
    const hasReducedMotionSet = document.documentElement.classList.contains('reduced-motion')
    if (this.getController) {
      this.getController.style.pointerEvents = 'none'
      this.getController.style.opacity = 0
    }

    if (hasReducedMotionSet) {
      this.hideVideoAndShowImage()
    } else {
      this.observer.observe(this.element)
    }
    this.registerEvents()
  }

  /**
   * @desc Creates an observer in which we can register our elements against
   * @param {HTMLElement} el - Image element
   */
  registerObserver() {
    const options = {
      root: null,
      rootMargin: '0px 0px -50%',
      threshold: 0
    }

    return new IntersectionObserver(this.controllerInView.bind(this), options)
  }

  /**
   * @desc Callback for intersectionObserver that says the image is in the viewport
   * and is ready to be displayed.
   * @param {HTMLElement} entries - List of image entries from the observer
   */
  controllerInView(elements) {
    elements.forEach(elem => {
      if (elem.isIntersecting) {
        if (!this.emittedOnce) {
          this.video.play()
          this.emittedOnce = true
        }
      }
    })
  }

  registerEvents() {
    this.emitter.on(GLOBAL_CONSTANTS.EVENTS.LOW_POWER_MODE, this.hideVideoAndShowImage.bind(this))
    this.video.addEventListener(GLOBAL_CONSTANTS.EVENTS.ENDED, this.hideVideoAndShowImage)
    this.video.addEventListener(GLOBAL_CONSTANTS.EVENTS.LOADED_DATA, this.setElementHeight)
    this.skip.addEventListener('click', this.skipVideo)
    window.addEventListener(GLOBAL_CONSTANTS.EVENTS.RESIZE, this.setElementHeight)
  }

  hideVideoAndShowImage = () => {
    this.skip.style.opacity = 0
    setTimeout(() => {
      this.element.style.opacity = 0
      this.controllerCarousel.style.pointerEvents = 'auto'
      this.controllerCarousel.style.opacity = 1
      if (this.getController) {
        this.getController.style.pointerEvents = 'auto'
        this.getController.style.opacity = 1
      }
    }, 500)
  }

  skipVideo = () => {
    this.video.pause()
    this.element.style.transitionDelay = '0s'
    this.hideVideoAndShowImage()
  }

  setElementHeight = () => {
    const videoHeight = this.video.offsetHeight
    this.element.style.height = videoHeight + 'px'
  }
}

/**
 * Add module objects alphabetically as needed
 * {
 *  selector: CSS selector for the target element(s)
 *  Source: Imported js class with a constructor. Constructor will be passed
 *      the target DOM element.
 * }
 */
export default {
  selector: SELECTORS.controllerVideo,
  Source: ControllerVideo
}
